import { SelectOption } from '@globaleris/ui.library'
import { EnumTipoMetodoPago } from '../api/oData/enums/enumTipoMetodoPago'
import i18n from '../i18n'
import { AnnexedParameters } from '../api/Argentia/enums'

export function enumToMap(enumeration: any): Map<string, string | number> {
  const map = new Map<string, string | number>()
  for (let key in enumeration) {
    //TypeScript does not allow enum keys to be numeric
    if (!isNaN(Number(key))) continue

    const val = enumeration[key] as string | number

    //TypeScript does not allow enum value to be null or undefined
    if (val !== undefined && val !== null) map.set(key, val)
  }

  return map
}

// Converts an Enum to Map
export const enumToMapValues = (enumeration: any): Map<string, number> => {
  const map = new Map<string, number>()
  for (let key in enumeration) {
    //TypeScript does not allow enum keys to be numeric
    if (!isNaN(Number(key))) continue

    const val = enumeration[key] as number

    //TypeScript does not allow enum value to be null or undefined
    if (val !== undefined && val !== null) map.set(key, val)
  }

  return map
}

export const enumToRecord = (enumeration: object): Record<string, number> => {
  return Object.entries(enumeration)
    .filter(([key, val]) => isNaN(Number(key)))
    .reduce<Record<string, number>>((obj, [key, val]) => {
      if (typeof val === 'number') {
        obj[key] = val
      }
      return obj
    }, {})
}

export const recordToMap = <T>(record: Record<number, T>): Map<number, T> => {
  const map = new Map<number, T>()
  Object.entries(record).forEach(([key, value]) => {
    map.set(Number(key), value)
  })
  return map
}

export function enumValuesToArray(enumeration: any): Array<string | number> {
  return Array.from(enumToMap(enumeration).values())
}

export function enumKeysToArray(enumeration: any): Array<string> {
  return Array.from(enumToMap(enumeration).keys())
}

export function enumToSelectOptionArray(enumeration: any, i18nPath: string): SelectOption[] {
  const keys = enumKeysToArray(enumeration)
  return enumValuesToArray(enumeration).map((key: any, index: number): SelectOption => {
    return { value: key, label: i18n.t(`${i18nPath}.${keys[index]}`) }
  })
}

export function enumToSelectOption(enumeration: any): SelectOption[] {
  const keys = enumKeysToArray(enumeration)
  return enumValuesToArray(enumeration).map((key: any, index: number): SelectOption => {
    return { value: key, label: `${keys[index]}` }
  })
}

export function enumTranslateOption(
  option: number,
  enumeration: { [key: number]: string },
  i18nPath: string
): string {
  const keys = enumKeysToArray(enumeration)
  const index = enumValuesToArray(enumeration).findIndex(x => x === option)
  return i18n.t(`${i18nPath}.${keys[index]}`)
}

// export function enumToSelectOptionArrayByValue(enumeration: any, i18nPath: string): SelectOption[] {
//   return enumValuesToArray(enumeration).map(
//     (key: any): SelectOption => {
//       return { value: key, label: i18n.t(`${i18nPath}.${enumKeysToArray(enumeration)[key]}`) };
//     }
//   );
// }

export function enumToSelectOptionArrayDefaultValues(
  enumeration: any,
  i18nPath: string,
  defaultValues: any[]
): SelectOption[] {
  let returnArray: SelectOption[] = []
  let arrayMapValues = enumValuesToArray(enumeration)
  let arrayMapKeys = enumKeysToArray(enumeration)

  for (let value of defaultValues) {
    let index = isNaN(value)
      ? enumKeysToArray(enumeration).findIndex(x => x === value)
      : enumValuesToArray(enumeration).findIndex(x => x === value)

    if (index > -1) {
      returnArray.push({
        value: arrayMapValues[index],
        label: i18n.t(`${i18nPath}.${arrayMapKeys[index]}`)
      })
    }
  }

  return returnArray
}

export function enumKeyToValue<T>(enumDef: T, key: any) {
  if (key !== null && key !== undefined) {
    return enumDef[key]
  }
}

export function enumValueToKey<T>(enumDef: T, value: any) {
  if (value !== null && value !== undefined) {
    return enumDef[value]
  }
}

export function enumKeyToValueString<T>(enumDef: T, key: any): string | undefined {
  if (key !== null && key !== undefined) {
    return enumDef[key]
  }
  return undefined
}

export function enumEnumToValueString<T extends { [key: string]: any }>(
  enumDef: T,
  value: any
): string | undefined {
  if (value !== null && value !== undefined) {
    if (typeof value === 'number') {
      return Object.values(enumDef).includes(value) ? enumDef[value] : undefined
    } else if (typeof value === 'string') {
      return value in enumDef ? value : undefined
    }
  }
  return undefined
}

export function enumEnumToValueNumber<T extends { [key: string]: any }>(
  enumDef: T,
  value: any
): number | undefined {
  if (value !== null && value !== undefined) {
    if (typeof value === 'string') {
      return Object.values(enumDef).includes(value) ? enumDef[value] : undefined
    } else if (typeof value === 'number') {
      return value in enumDef ? value : undefined
    }
  }
  return undefined
}

export type StringValues<T> = {
  [K in keyof T]: T[K] extends string ? T[K] : never
}[keyof T]

export type NumberValues<T> = {
  [K in keyof T]: T[K] extends number ? T[K] : never
}[keyof T]

/**
 * Usage : type EnumValues = EnumAsUnion<typeof anEnum>
 */
// Needs Typescript 5.0
// export type EnumAsUnion<T> = `${StringValues<T>}` | NumberValues<T>

// Helper para crear literales a partir de Enums
// Ej: Transferencia37DiasFechaConsumo => "Transferencia 37 Dias Fecha Consumo"

export const ConvertKeysToCommonLanguageLabels = () => {
  const keys = enumKeysToArray(AnnexedParameters)
  const list = enumValuesToArray(AnnexedParameters).map((key: any, index: number): SelectOption => {
    return { value: key, label: keys[index] }
  })
  // console.log(list)
  let obj = {}
  list.forEach((x, idx) => {
    // console.log(x.label)
    const elementLabel = x.label
    // console.log(elementLabel)
    const splitted = elementLabel
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([a-z])([0-9])/g, '$1 $2')
      .replace(/([A-Z])([a-z])/g, ' $1$2')
      .replace(/\ +/g, ' ')
      .replace(/_/g, ' ')
    //

    obj[`${elementLabel}`] = splitted
  })
  console.log(obj)
}

// Helper functions to get enum labels by ID
export const getEnumLabel = (enumObject: any, id: number): string => {
  const enumKeys = Object.keys(enumObject).filter(key => !isNaN(Number(enumObject[key])))
  const enumKey = enumKeys.find(key => enumObject[key] === id)
  return enumKey || `ID ${id}`
}

export function enumToKeyValueArray<T extends Record<string, number>>(
  enumeration: T
): Array<{ [key: string]: number }> {
  return Object.entries(enumeration)
    .filter(([key, _]) => isNaN(Number(key)))
    .map(([key, value]) => ({ [key]: value as number }))
}

// Uso:
// enumToKeyValueArray(EnumCommodity)
// Resultado: [{GasNatural: 1}, {EnergiaElectrica: 2}]

export function enumToObjectArray<T extends Record<string, number>>(
  enumeration: T
): Array<{ key: string; value: number }> {
  return Object.entries(enumeration)
    .filter(([key, _]) => isNaN(Number(key)))
    .map(([key, value]) => ({ key, value: value as number }))
}

// Resultado: [{key: "GasNatural", value: 1}, {key: "EnergiaElectrica", value: 2}]
